<template>
  <div class="relative w-$portalContainerWidth mx-auto mt-20px h-800px">
    <NavigationBarProps></NavigationBarProps>
    <el-row :gutter="10" class="h-full">
      <el-col :span="7" class="h-full">
        <el-card class="h-full w-full mr-10px" :body-style="{ height: '100%' }">
          <div class="flex">
            <el-input
              v-model="treeKeyword"
              placeholder="搜索部门"
              class="mr-10px"
              prefix-icon="el-icon-search"
              @clear="searchTreeData"
            ></el-input>
            <el-button type="primary" @click="searchTreeData">搜索</el-button>
          </div>
          <el-tree
            class="mt-20px overflow-y-auto h-[calc(100%-56px)]"
            :data="treeData"
            highlight-current
            :expand-on-click-node="false"
            @node-click="handleNodeClick"
            :props="defaultTreeProps"
            :filter-node-method="filterDepartMentNode"
            node-key="id"
            ref="departmentTree"
            :default-expanded-keys="defaultExpandedKeys"
          >
          </el-tree>
        </el-card>
      </el-col>
      <el-col :span="17" class="h-full">
        <el-card class="h-full w-full mr-10px" :body-style="{ height: '100%' }">
          <el-input
            size="small"
            clearable
            placeholder="搜索人员姓名"
            class="!w-280px mr-10px"
            v-model="searchPeople"
            prefix-icon="el-icon-search"
            @clear="getUserList"
          />
          <el-button size="small" type="primary" @click="getUserList">搜索</el-button>
          <el-table height="calc(100% - 100px)" class="mt-20px" border stripe :data="tableData">
            <el-table-column type="index" width="60" label="序号"></el-table-column>
            <el-table-column
              label="所属部门"
              width="330px"
              show-overflow-tooltip
              sortable
              prop="orgUnits"
            >
              <template slot-scope="scope">
                <el-tag
                  class="mx-5px"
                  size="mini"
                  v-for="item in scope.row.orgUnits"
                  :key="item.id"
                  >{{ item.organizationUnitName }}</el-tag
                >
              </template>
            </el-table-column>
            <el-table-column label="职务" show-overflow-tooltip sortable prop="posts">
              <template slot-scope="scope">
                <el-tag class="mx-5px" size="mini" v-for="item in scope.row.posts" :key="item.id">{{
                  item.postName
                }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="姓名" prop="name" align="center"> </el-table-column>
            <el-table-column label="手机" prop="phoneNumber" align="center"> </el-table-column>
          </el-table>
          <div class="flex justify-end mt-20px">
            <el-pagination
              background
              @size-change="searchList"
              @current-change="getUserList"
              :current-page.sync="page.pageNo"
              layout="total, sizes, prev, pager, next, jumper"
              :page-size.sync="page.pageSize"
              :total="page.total"
              :page-sizes="[15, 30, 45, 60, 75, 90]"
              :pager-count="5"
            >
            </el-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { EafOrganizationUnitUserApi } from '@wiz-api/account'
import { OrganizationApi } from '@wiz-api/abp-identity'
import NavigationBarProps from '../components/NavigationBarProps'

const eafOrganizationUnitUserApi = new EafOrganizationUnitUserApi()
const organizationApi = new OrganizationApi()
export default {
  name: 'AddressBook',
  components: {
    NavigationBarProps,
  },
  data() {
    return {
      defaultTreeProps: {
        children: 'children',
        label: 'displayName',
      },
      treeData: [], // 目录树数据
      tableData: [],
      treeKeyword: '',
      keyword: '',
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      searchPeople: null,
      defaultExpandedKeys: [],
      departmentId: '',
    }
  },
  created() {
    const { config } = Wiz.globalSettings.dynamicModules.modules['portal-homepage-nanhai']
    document.title = `通讯录 - ${config.title}`
    this.getAllTreeListDetails()
  },
  methods: {
    searchTreeData() {
      this.$refs.departmentTree.filter(this.treeKeyword)
    },
    filterDepartMentNode(value, data) {
      if (!value) return true
      return data.displayName.indexOf(value) !== -1
    },
    handleNodeClick(data) {
      this.departmentId = data.id
      this.getUserList()
    },
    // 获取整个目录树
    async getAllTreeListDetails() {
      const [err, res] = await organizationApi.getAllListDetails({
        Filter: '',
        Sorting: '',
      })
      if (!err) {
        this.treeData = res.items
        this.defaultExpandedKeys = [this.treeData[0].id]
        this.getUserList()
      }
    },
    // 获取用户列表
    async getUserList() {
      const [err, res] = await eafOrganizationUnitUserApi.getOrganizationUnitUserList({
        organizationUnitId: this.departmentId,
        includeOrgChild: true, // 是否查询该部门子部门人员
        userName: this.searchPeople,
        skipCount: this.page.pageSize * (this.page.pageNo - 1),
        maxResultCount: this.page.pageSize,
      })
      if (!err) {
        this.tableData = res.items
        this.page.total = res.totalCount
      }
    },
    searchList() {
      this.page.pageNo = 1
      this.getUserList()
    },
    findList() {},
  },
}
</script>

<style></style>
